import { ManualService } from './../../manuals/services/manual.services';
import { EmployeeSicknessServices } from './employeesickness.service';
import { User } from './../../users/models/user';
import { BaseServices } from './../../kuba.services';
import { EmployeeLeaveService } from './employeeleave.service';
import { EmployeeLeave } from './../models/employeeLeave';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ResponsibleExecution } from 'src/app/kuba/employees/models';
import { tap } from 'rxjs/operators';


@Injectable()
export class EmpLeaveListResolver {
  constructor(private backend: EmployeeLeaveService) { }
  resolve(): Observable<EmployeeLeave[]> {
    return this.backend.getAllByBusinessId(BaseServices.BusinessId, new Date().getFullYear());
  }
}

@Injectable()
export class ApprovalPersonResolver {
  constructor(private backend: EmployeeLeaveService) { }
  resolve(route: ActivatedRouteSnapshot) {
    if (BaseServices.roleId === '2') {
      return null;
    }
    return this.backend.getAllApprovedPerson();
  }
}
@Injectable()
export class EmpLeaveByLeaveResolver {
  constructor(private backend: EmployeeLeaveService) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getEmployeeLeaveByLeaveId(+route.params['lid'] ? +route.params['lid'] : 0);
  }
}

@Injectable()
export class SicknessAbsenceCodeResolver {
  constructor(private backend: EmployeeSicknessServices) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getSicknessAbsenceCode(BaseServices.BusinessId);
  }
}
@Injectable()
export class ResposibleExecutionResolver {
  constructor(private backend: ManualService) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getBusinessUserListForManuals(BaseServices.BusinessId);
  }
}
@Injectable()
export class BusinessHolidaysResolver {
  constructor(private backend: EmployeeLeaveService) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAllHolidays(BaseServices.BusinessId).pipe(tap((data) => console.log("FROM SERVER", data)));
  }
}

